import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(pageNo, data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/Post/${pageNo}?${params}`);
  },
  create(data) {
    return api.post(`/api/Post`, data);
  },
  getById(id) {
    return api.get(`/api/Post/byId/${id}`);
  },
  update(id, data) {
    return api.put(`/api/Post/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/Post/${id}`);
  },
};
